/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ArrowSwooshShareIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ArrowSwooshShareIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M12.2929 6.00001L9.14645 2.85356L9.85355 2.14645L14.2071 6.50001L9.85355 10.8536L9.14645 10.1465L12.2929 7.00001H8.5C6.567 7.00001 5 8.56701 5 10.5V13H4V10.5C4 8.01473 6.01472 6.00001 8.5 6.00001H12.2929Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ArrowSwooshShareIcon.tags = ['forward', 'send', 'redirect', 'share', 'upload'];

ArrowSwooshShareIcon.category = 'Arrows';

ArrowSwooshShareIcon.iconSize = 16;
